import { GenericService } from '../GenericService'

class UserResponseService extends GenericService {
    constructor() {
        super('/api/userResponses/customerResponses')
    }

    customerResponses = (data) =>
        this.post('/api/userResponses/customerResponses', data)
}

export default new UserResponseService()
